import NavigationService from './NavigationService'
import * as pages from '../../common_constants/Pages'

function navigateToAdmin(crsf) {
  window.location.href = `${process.env.REACT_APP_ADMIN_BASE_URL}?crsf=${crsf}`
  return null
}

function navigateToExternal(url) {
  window.location.href = url
  return null
}

function navigateToDomain(domainNS) {
  window.location.replace(`${process.env.REACT_APP_PUBLIC_BASE_URL}/${domainNS}/explore`)
  return null
}

function navigateBack() {
  NavigationService.getHistory().goBack()
}

function navigateToChallenges() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.CHALLENGES_PAGE].path)
}

function navigateToChallengeDetail(id) {
  const ROUTES = NavigationService.getRoutes()
  const toChallenge = ROUTES[pages.DETAIL_CHALLENGE].path.replace(':id', id)
  NavigationService.getHistory().push(toChallenge)
}

function navigateToChallengeForm(id) {
  const ROUTES = NavigationService.getRoutes()
  const toChallenge = ROUTES[pages.EDIT_CHALLENGE].path.replace(':id', id)
  NavigationService.getHistory().push(toChallenge)
}

function navigateToChallengeNew() {
  const ROUTES = NavigationService.getRoutes()
  const toChallenge = ROUTES[pages.NEW_CHALLENGE].path
  NavigationService.getHistory().push(toChallenge)
}

function navigateToProposeChallenge() {
  const ROUTES = NavigationService.getRoutes()
  const toProposeChallenge = ROUTES[pages.PROPOSE_CHALLENGE].path
  NavigationService.getHistory().push(toProposeChallenge)
}

function navigateToDashboard() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.DASHBOARD].path)
}

function navigateToExplore() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.EXPLORE_PAGE].path)
}

function navigateToHowItWorks() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.HOW_IT_WORKS].path)
}

function navigateToNewIdea(challengeId = '') {
  const ROUTES = NavigationService.getRoutes()
  const toIdea = challengeId
    ? ROUTES[pages.NEW_IDEA_CHALLENGE_SELECTED].path.replace(':challengeId', challengeId)
    : ROUTES[pages.NEW_IDEA].path
  NavigationService.getHistory().push(toIdea)
}

function navigateToNewPrivateIdea() {
  const ROUTES = NavigationService.getRoutes()
  const toIdea = ROUTES[pages.NEW_PRIVATE_IDEA].path
  NavigationService.getHistory().push(toIdea)
}

function navigateToEditIdea(id) {
  const ROUTES = NavigationService.getRoutes()
  const toIdea = ROUTES[pages.EDIT_IDEA].path.replace(':id', id)
  NavigationService.getHistory().push(toIdea)
}

function navigateToIdea(id) {
  const ROUTES = NavigationService.getRoutes()
  const toIdea = ROUTES[pages.DETAIL_IDEA].path.replace(':id', id)
  NavigationService.getHistory().push(toIdea)
}

function navigateToIdentityChoose() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.IDENTITY_CHOOSE_PAGE].path)
}

function navigateToMyIdeas() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.MY_IDEAS_PAGE].path)
}

function navigateToInvestments() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.INVESTMENTS_PAGE].path)
}

function navigateToLogout() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.LOGOUT_PAGE].path)
}

function navigateToLogin() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.LOGIN_PAGE].path)
}

function navigateToPendingValidation() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.PENDING_VALIDATION_PAGE].path)
}

function navigateToPrivateIdeas() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.PRIVATE_IDEAS_PAGE].path)
}

function navigateToProfile() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.PROFILE_PAGE].path)
}

function navigateToRanking() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.RANKING_PAGE].path)
}

function navigateToSettings() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.USER_PREFERENCES_PAGE].path)
}

function navigateToUserProfile(email) {
  const ROUTES = NavigationService.getRoutes()
  const toProfile = ROUTES[pages.PROFILE_PAGE_USER].path.replace(':email', email)
  NavigationService.getHistory().push(toProfile)
}

function navigateToUserRequestInvest(email) {
  const ROUTES = NavigationService.getRoutes()
  const toProfile = ROUTES[pages.PROFILE_PAGE_USER].path.replace(':email', email)
  NavigationService.getHistory().push(`${toProfile}?requestOpen=true`)
}

function navigateToSignUp(domain) {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.SIGN_UP].path.replace(':domain', domain))
}

function navigateToCustomLogin(domain) {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(
    ROUTES[pages.CUSTOM_LOGIN_PAGE].path.replace(':domain', domain),
  )
}

function navigateToLegalAcceptance() {
  const ROUTES = NavigationService.getRoutes()
  NavigationService.getHistory().push(ROUTES[pages.LEGAL_ACCEPTANCE_PAGE].path)
}

// STATIC EXTERNAL URLS

function navigateToStaticHelpNextinit() {
  navigateToExternal('https://help.nextinit.com/')
}

export default {
  navigateBack,
  navigateToAdmin,
  navigateToChallengeDetail,
  navigateToChallengeForm,
  navigateToChallengeNew,
  navigateToProposeChallenge,
  navigateToChallenges,
  navigateToDashboard,
  navigateToDomain,
  navigateToExplore,
  navigateToExternal,
  navigateToHowItWorks,
  navigateToIdea,
  navigateToNewIdea,
  navigateToNewPrivateIdea,
  navigateToEditIdea,
  navigateToIdentityChoose,
  navigateToMyIdeas,
  navigateToInvestments,
  navigateToLogout,
  navigateToPendingValidation,
  navigateToPrivateIdeas,
  navigateToProfile,
  navigateToRanking,
  navigateToSettings,
  navigateToSignUp,
  navigateToStaticHelpNextinit,
  navigateToUserProfile,
  navigateToUserRequestInvest,
  navigateToLogin,
  navigateToCustomLogin,
  navigateToLegalAcceptance,
}
